import {CounterpartyType} from "@/constants/CounterpartyType";
import {PayPeriodType, PayType} from "@/constants/TarifficationConstants";
import {DateTime} from "luxon";
import {ContractType} from "@/constants/EmploymentType";

export default class RegisterContractorPayload {
    employerId: number | null = null;
    contractorId: number | null = null;
    branchIds: Array<number> = [];
    contractStart: Date | null = null;
    type: CounterpartyType = CounterpartyType.COMPANY;
    payType: PayType | null = null;
    payPeriodType: PayPeriodType | null = null;
    rate: number | null = null;
    contractType = ContractType.FIXED_TERM;
    zoneId = DateTime.local().zoneName
}